module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.countryContactsMappingMap) ? _c('isrs-country-mapping-form', {
    attrs: {
      "countries-selected": _vm.countryContactsMappingMap,
      "contacts": _vm.contacts
    },
    on: {
      "change": _vm.countryContactsMappingChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSaveButton) ? _c('v-btn', {
    attrs: {
      "block": "",
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.countryContactMappingsUpdated()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-16d16b58"}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/returnShopPortals/Mappings.vue
// module id = 922
// module chunks = 1